/* @flow */

import * as React from 'react';
import type {FieldProps} from 'redux-form';

import {SelectPickerGeneric, type SelectPickerGenericProps} from '../../select-picker-generic';
import {FormField} from '../../form';

type OwnProps = {|
    title?: string,
    helperText: string,
    autoFocus?: boolean,
    isMulti?: boolean,
    isRequired?: boolean,
    ...SelectPickerGenericProps,
|};

type Props = {...$Exact<FieldProps>, ...OwnProps};

export function ReduxFormSelectPickerGeneric(props: Props) {
    const {autoFocus = true, title, helperText, isRequired, input, meta, ...restProps} = props;

    return (
        <FormField
            innerId={input.name}
            label={title}
            helperText={helperText}
            errorMessage={meta.error && meta.submitFailed ? meta.error : null}
            isRequired={isRequired}
        >
            {/* $FlowIgnore I can't get this to work because of the exact prop types */}
            <SelectPickerGeneric
                autoFocus={autoFocus}
                {...input}
                {...restProps}
                onBlur={() => {
                    // Who can explain it, who can tell why. Somehow, this
                    // works. If the params are passed through, the value for
                    // this field is reset on blur :shrug:
                    input.onBlur();
                }}
                onChange={(option) => {
                    input.onChange(option.value);
                }}
            />
        </FormField>
    );
}
